// extracted by mini-css-extract-plugin
export default {"signaturePad":"Waiver_signaturePad__+ho2Q","clearSignatureButton":"Waiver_clearSignatureButton__3rZCL"};